import React, { ReactElement } from 'react';
import { FormInstance } from 'antd/lib/form';

import { useClientFormContext } from '../ClientFormContext';
import ClientFormHeader from '../../../components/Client/ClientFormHeader';
import ClientForm from '../ClientForm';
import { submitQuoteDenyingConfigFactory } from '../utils/submit';
import ClosingScheduleFormSection from '../../../components/Feature/QuoteDenying/ClosingScheduleFormSection';
import CutOffFormSection from '../../../components/Feature/QuoteDenying/CutOffFormSection';
import PackageMaxDimensionsFormSection from '../../../components/Feature/QuoteDenying/PackageMaxDimensionsFormSection';
import TransportTypeLimitationsSection from '../../../components/Feature/QuoteDenying/TransportTypeLimitationsSection';
import QuoteConfigFormSection from '../../../components/Feature/QuoteDenying/QuoteConfigFormSection';

const ClientQuoteDenialToolForm: React.FC = (): React.ReactElement => {
    const { client, data, formConfig, setData } = useClientFormContext();

    const submitForm = async (form: FormInstance): Promise<void> => {
        if (!client) return;

        const quoteDenying = await submitQuoteDenyingConfigFactory(client.id, data.quoteDenying)(form);
        setData({ ...data, quoteDenying });
    };

    return (
        <>
            <div className="shadow-sm pb-4">
                <ClientFormHeader />
                <div className="px-4">
                    <ClientForm name="quoteDenying" submitForm={submitForm}>
                        {({ form }): ReactElement => (
                            <>
                                <QuoteConfigFormSection
                                    formInstance={form}
                                    config={data.quoteDenying}
                                    isDetailMode={formConfig.isDetailMode}
                                />
                                <TransportTypeLimitationsSection
                                    formInstance={form}
                                    transportLimitationsConfig={data.quoteDenying}
                                    isDetailMode={formConfig.isDetailMode}
                                />
                                <ClosingScheduleFormSection
                                    formInstance={form}
                                    closingScheduleConfig={data.quoteDenying}
                                    isDetailMode={formConfig.isDetailMode}
                                />
                                <CutOffFormSection
                                    formInstance={form}
                                    quoteDenyingConfig={data.quoteDenying}
                                    isDetailMode={formConfig.isDetailMode}
                                />
                                <PackageMaxDimensionsFormSection
                                    formInstance={form}
                                    packageMaxDimensionsConfig={data.quoteDenying}
                                    isDetailMode={formConfig.isDetailMode}
                                />
                            </>
                        )}
                    </ClientForm>
                </div>
            </div>
        </>
    );
};

export default ClientQuoteDenialToolForm;
